import React, { useState, useEffect, Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import { HelmetProvider } from "react-helmet-async";
import SEO from "./Components/SEO";

import reportWebVitals from "./reportWebVitals";

import Header from "./Components/Header/Header";
import Main from "./Components/Main-p/Main";
import About from "./Components/About/About";
import Gallery from "./Components/Gallery/Gallery";
import Before from "./Components/Before/Before";
import Feedback from "./Components/Feedback/Feedback";
import FeedbackNew from "./Components/FeedbackNew/FeedbackNew";
import Order from "./Components/Order/Order";
import Footer from "./Components/Footer/Footer";
import Price from "./Components/Price/Price";

import Popup from "./shared/ui/Popup/Popup";

import CookieConsent from "./Components/CookieConsent/CookieConsent";
import PrivacyPolicy from "./Components/Policy/PrivacyPolicy";

import ConfectionersStore from "./Components/ConfectionersStore/ConfectionersStore";

// import img_popup from "./Components/Photo/popup.jpg";
import fb from "./Photo/23fb.jpg";

import { BrowserRouter, Route, Routes } from "react-router-dom"; 

// ЛЕНИВАЯ ЗАГРУЗКА АДМИНКИ (Code Splitting)
const AdminPage = lazy(() => import("./Components/Admin/AdminPage/AdminPage"));

const Popups = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    setIsPopupOpen(true); 
    document.body.style.overflow = "hidden";
  }, []);

  const handleClose = () => {
    setIsPopupOpen(false); 
    document.body.style.overflow = "auto";
  };

  return (
    <div>
      {isPopupOpen && (
        <Popup
          className="popup"
          handleClose={handleClose}
          image={fb}
          title="С Днём защитника Отечества! 🎖️"
          description={
            <>
              <span
                style={{
                  background:
                    "linear-gradient(45deg, #4B5320, #6B8E23, #A67B5B, #C0A080)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  textDecoration: "none",
                  fontWeight: "bold",
                }}
              >
                23 февраля
              </span>{" "}
              — день силы, мужества и отваги! Это прекрасный повод сказать
              тёплые слова благодарности тем, кто оберегает и защищает. Только
              до{" "}
              <span
                style={{
                  background:
                    "linear-gradient(45deg, #4B5320, #6B8E23, #A67B5B, #C0A080)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  textDecoration: "none",
                  fontWeight: "bold",
                }}
              >
                21 февраля
              </span>{" "}
              на сайте доступны уникальные десерты, созданные специально к этому
              празднику. Порадуйте близких особенным вкусом и атмосферой! 💙
            </>
          }
        />
      )}
    </div>
  );
};

const App = () => {
  const [dataProduct, setDataProduct] = useState(null);
  const [dataProductStore, setDataProductStore] = useState(null);

  return (
    <HelmetProvider>
      <Routes>
        {/* АДМИНКА */}
        <Route 
          path="/admin" 
          element={
            <Suspense fallback={<div style={{ textAlign: 'center', padding: '50px' }}>Загрузка панели управления...</div>}>
              <AdminPage />
            </Suspense>
          } 
        />
        
        <Route path="/old-feedback" element={<Feedback />} />
        <Route path="/policy" element={<PrivacyPolicy />} />
        
        {/* НОВАЯ СТРАНИЦА: Для кондитеров */}
        <Route 
          path="/for-confectioners" 
          element={
            <>
              {/* SEO: Оптимизировано для поисковых запросов B2B и хобби-кондитеров */}
              <SEO 
                title="Все для кондитера в Чехове | Инвентарь, упаковка и декор" 
                description="Проверенный кондитерский инвентарь, упаковка и декор от профессионала. Качественные товары для тортов, капкейков и моти с доставкой. Заказывайте то, чем пользуются профи!" 
                name="Магазин для кондитеров от Даши" 
                type="website" 
              />
              <Header />
              <ConfectionersStore setProduct={setDataProductStore}/>
              <Order data={dataProductStore} />
              <Footer />
            </>
          } 
        />

        {/* Основной сайт (Лендинг) */}
        <Route 
          path="*" 
          element={
            <>
              {/* SEO: Оптимизировано для локального поиска (Чехов) и высокой конверсии */}
              <SEO
                title="Торты на заказ в Чехове | Авторские десерты от Даши"
                description="Авторские торты, бенто и капкейки на заказ в Чехове. Натуральные ингредиенты, стильный декор и бесплатная доставка. Закажите идеальный десерт для вашего праздника прямо сейчас!"
                name="Кондитерская Даши | Торты на заказ Чехов"
                type="website"
              />
              <Header />
              <Main />
              {/* <About /> */}
              <Price setProduct={setDataProduct} />
              <Order data={dataProduct} />
              <Gallery />
              <Before />
              <FeedbackNew />
              <Footer />
              <CookieConsent />
            </>
          } 
        />
      </Routes>
    </HelmetProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();